export default "__VITE_ASSET__BzlWARVq__"